<template>
  <div class="page-full">

    <!-- Admin dashboard -->
    <div v-show="adminMode">Admin dashboard coming soon</div>

    <!-- Partner dashboard -->
    <div v-show="partnerMode">Partner dashboard coming soon</div>

    <!-- Account dashboard -->
    <div class="grid-container" v-show="account.id">

      <div class="grid-item score">
        {{exposure.score}}
      </div>

      <div class="grid-item risk">
        <Plot :data="plotDataRiskByCategory" :layout="plotLayoutRiskByCategory" :div-id="`plot-risk`"/>
      </div>

      <div class="grid-item trend">
        <Plot :data="plotDataTrends" :layout="plotLayoutTrends" :div-id="`plot-trend`"/>
      </div>

      <div class="grid-item category">
          <Plot :data="plotDataAlertsByCategory" :layout="plotLayoutAlertsByCategory" :div-id="`plot-category`"/>
      </div>

    </div>

    <pre class="debug" v-show="debugMode">{{ exposure }}</pre>

  </div>
</template>

<style scoped>
.grid-container {
  display: grid;
  grid-gap: 10px;
  grid-template-areas:
    'score risk'
    'trends category'
}
.grid-item {
  text-align: center;
  background-color: #eeeeee
}
.score {
  padding-top: 25%;
  font-size: 72px;
}
.trend {
}
</style>

<script>
// @ is an alias to /src
// import Account from '@/components/Account.vue'
import Plot from '@/components/Plot.vue'

import { mapState } from 'vuex'

export default {
  name: 'dashboard',
  components: {
    Plot
  },
  computed: {
    plotDataTrends: function () {
      if (!this.exposure.trend) return []
      /* Collect date labels */
      // var dates = []
      // for (var date in this.exposure.trend) {
      //   dates.push(date)
      // }
      // dates.sort()
      // console.log('dates', dates)
      /* Collect data */
      var x = []
      var risk = []
      var alerts = []
      for (var date in this.exposure.trend) {
        x.push(date)
        risk.push(this.exposure.trend[date]['risk'])
        alerts.push(this.exposure.trend[date]['alerts'])
      }
      // var trace_risk = {x: x, y: risk, type: 'bar', name: 'Risk'}
      // var trace_alerts = {x: x, y: alerts, type: 'bar', name: 'Alerts'}
      var trace_risk = {x: x, y: risk, mode: 'lines+markers', type: 'scatter', line: {shape: 'spline'}, name: 'Risk'}
      var trace_alerts = {x: x, y: alerts, mode: 'lines+markers', type: 'scatter', line: {shape: 'spline'}, name: 'Alerts'}
      var data = [trace_alerts, trace_risk]
      return data
    },
    plotDataRiskByCategory: function () {
      if (!this.exposure.by_category) return []
      var values = [
        this.exposure.by_category.sensitivedisclosure.risk,
        this.exposure.by_category.discussions.risk,
        this.exposure.by_category.blackmarkets.risk,
        this.exposure.by_category.financialinformation.risk,
        this.exposure.by_category.exposedcredentials.risk,
        this.exposure.by_category.personalinformation.risk,
        this.exposure.by_category.hackergrouptargeting.risk,
        this.exposure.by_category.attacksandcompromises.risk,
        this.exposure.by_category.unidentified.risk
      ]
      var data = [{values: values, labels: this.exposureCategories, type: 'pie'}]
      return data
    },
    plotDataAlertsByCategory: function () {
      if (!this.exposure.by_category) return []
      var values = [
        this.exposure.by_category.sensitivedisclosure.alerts,
        this.exposure.by_category.discussions.alerts,
        this.exposure.by_category.blackmarkets.alerts,
        this.exposure.by_category.financialinformation.alerts,
        this.exposure.by_category.exposedcredentials.alerts,
        this.exposure.by_category.personalinformation.alerts,
        this.exposure.by_category.hackergrouptargeting.alerts,
        this.exposure.by_category.attacksandcompromises.alerts,
        this.exposure.by_category.unidentified.alerts
      ]
      var data = [{values: values, labels: this.exposureCategories, type: 'pie'}]
      return data
    },
    ...mapState([
      'debugMode',
      'adminMode',
      'partnerMode',
      'accountMode',
      'account',
      'profile',
      'exposure'
    ])
  },
  methods: {
    refreshExposure () {
      if (!this.account.id) return
      this.$store.dispatch('loadExposure')
    }
  },
  watch: {
    profile () {
      this.refreshExposure()
    }
  },
  mounted () {
    this.refreshExposure()
  },
  data () {
    return {
      exposureCategories: [
        'Sensitive disclosure',
        'Discussions',
        'Black markets',
        'Financial information',
        'Exposed credentials',
        'Personal information',
        'Hacker group targeting',
        'Attacks & compromises',
        'Unidentified'
      ],
      plotLayoutTrends: {
        title: 'Trend',
        width: '100%',
        plot_bgcolor: '#eeeeee',
        paper_bgcolor: '#eeeeee',
        yaxis: {
          // type: 'log',
          autorange: true,
          showgrid: false,
          showticklabels: false
        }
      },
      plotLayoutRiskByCategory: {
        title: 'Risk by category',
        width: '100%',
        plot_bgcolor: '#eeeeee',
        paper_bgcolor: '#eeeeee',
      },
      plotLayoutAlertsByCategory: {
        title: 'Alerts by category',
        width: '100%',
        plot_bgcolor: '#eeeeee',
        paper_bgcolor: '#eeeeee',
      }
    }
  },
}

</script>
